import { useQuery } from "@tanstack/react-query";
import { fetchStudiomateSchedules } from "@/services/studiomate-schedule";
import { isDemoMode } from "@/demo/demoMode";
import * as demoStore from "@/demo/demoStore";
import type { GetStudiomateSchedulesResponse } from "@vlab-corporation/studiomate-api";

type ScheduleParams = { date: string } | { startDate: string; endDate: string };

export function useStudiomateSchedules(params: ScheduleParams, centerId?: number) {
  const demo = isDemoMode();
  const queryKey = demo ? ["demo-schedules", params] : ["studiomate-schedules", centerId, params];

  return useQuery<GetStudiomateSchedulesResponse>({
    queryKey,
    queryFn: async () => {
      if (demo) {
        const date = "date" in params ? params.date : params.startDate;
        const classes = demoStore.getClassesForDate(date, "demo-instructor");
        return {
          schedules: classes.map((c) => ({
            id: Number(c.id) || 0,
            title: c.type === "regular" ? "정규 수업" : "OT 수업",
            type: "P" as const,
            startTime: "10:00",
            endTime: "11:00",
            date: c.date,
            staffName: "데모 강사",
            staffId: 0,
            currentTrainees: 1,
            maxTrainees: 1,
            bookings: [],
          })),
        };
      }
      const fetchParams = "date" in params ? params.date : params;
      return fetchStudiomateSchedules(fetchParams, centerId);
    },
    staleTime: 5 * 60 * 1000,
  });
}
